import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CustomValidatorService } from '../../../service/custom-validator.service';
import { ProviderService } from '../../../service/provider.service';

@Component({
  selector: 'app-provider-detail',
  templateUrl: './provider-detail.component.html',
  styleUrls: ['./provider-detail.component.less']
})
export class ProviderDetailComponent implements OnInit {
  @Input() pno: any;
  constructor(
    private customValidatorService: CustomValidatorService,
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  async ngOnInit(): Promise<void> {
  }
}
